import React, {  useContext } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { AppRoutes } from './app.routes';
import { Context } from '../contexts/GlobalContext';
import { useTheme } from 'native-base';
export function Routes() {
  const { state } = useContext(Context);
  const { colors } = useTheme();

  const MyTheme = {
    dark: state.colorScheme === 'dark',
    colors: {
      primary: colors.Label.Primary,
      background: colors.Background.Primary,
      card: colors.Background.Secondary,
      text: colors.Label.Primary,
      border: 'transparent',
      notification: colors.Red,
    },
  };
  return (
    <NavigationContainer theme={MyTheme}>
      <AppRoutes/>
    </NavigationContainer>
  )
}